import React, { forwardRef } from 'react';
import classNames from '../../utils/classNames';

export const baseFieldClasses =
    'focus:shadow-outline w-full appearance-none rounded border border-neutral-300 bg-white px-2 read-only:cursor-not-allowed disabled:cursor-not-allowed disabled:pointer-events-none leading-normal focus:outline-none';

export const inputFieldClasses = `${baseFieldClasses} text-form-text`;

export enum INPUT_SIZE {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE',
}

export type InputType = 'text' | 'number' | 'checkbox' | 'password';

const SIZE_CLASSES = Object.freeze({
    [INPUT_SIZE.SMALL]: 'py-1',
    [INPUT_SIZE.MEDIUM]: 'py-2',
    [INPUT_SIZE.LARGE]: 'py-4',
});

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, size = INPUT_SIZE.LARGE, type = 'text', error, ...props }, ref) => {
        // `disabled:pointer-events-none` is to allow onClick event on disabled
        // input's in Chrome. This is needed to show the `areYouSureToOverride` confirm.
        const classes =
            type === 'checkbox'
                ? ''
                : classNames(
                      inputFieldClasses,
                      SIZE_CLASSES[size],
                      error && 'border-red-500',
                      props.readOnly && 'cursor-not-allowed',
                      className
                  );

        return <input ref={ref} className={classes} type={type} {...props} />;
    }
);

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
    className?: string;
    error?: boolean | string | Record<string, unknown>;
    type?: InputType;
    step?: number;
    size?: INPUT_SIZE;
    readOnly?: boolean;
}

Input.displayName = 'Input';

export default Input;
